var InputErrorPositions;
(function (InputErrorPositions) {
  InputErrorPositions["Bottom"] = 'bottom';
  InputErrorPositions["Top"] = 'top';
})(InputErrorPositions || (InputErrorPositions = {}));
var InputLabelPositions;
(function (InputLabelPositions) {
  InputLabelPositions["Left"] = 'left';
  InputLabelPositions["Right"] = 'right';
  InputLabelPositions["Top"] = 'top';
})(InputLabelPositions || (InputLabelPositions = {}));
var InputLooks;
(function (InputLooks) {
  InputLooks["Default"] = 'default';
})(InputLooks || (InputLooks = {}));
export { InputErrorPositions, InputLabelPositions, InputLooks };